import './Pagination.scss'
import LeftSvg from '../../assets/svg/LeftSvg.jsx'
import RightSvg from '../../assets/svg/RightSvg.jsx'
import { useEffect, useRef, useState } from 'react'
import gsap from 'gsap'

function Pagination({ ref, page, setPage, vlCards, limit }) {
    const [rightClicked, setRightClicked] = useState(false)
    const [leftClicked, setLeftClicked] = useState(false)
    const rightRef = useRef(null)
    const leftRef = useRef(null)
    const vlPages = Math.ceil(vlCards / limit)

    useEffect(() => {
        if (rightClicked) {
            gsap.fromTo(rightRef.current, {scale: 1}, {
                scale: .9,
                duration: .1,
                ease: "power2.out",
                onComplete: () => setRightClicked(false)
            })
        } else {
            gsap.to(rightRef.current, {
                scale: 1,
                duration: .1,
                ease: "power2.in",
            })
        }

        if (leftClicked) {
            gsap.fromTo(leftRef.current, {scale: 1}, {
                scale: .9,
                duration: .1,
                ease: "power2.out",
                onComplete: () => setLeftClicked(false)
            })
        } else {
            gsap.to(leftRef.current, {
                scale: 1,
                duration: .1,
                ease: "power2.in",
            })
        }
    }, [rightClicked, leftClicked])

    const onLeft = () => {
        setLeftClicked(true)
        setPage(prev => Math.max(1, prev - 1))
    }

    const onRight = () => {
        setRightClicked(true)
        setPage(prev => Math.min(vlPages, prev + 1))
    }

    return (
        <div className='pagination-wrapper' ref={ref}>
            <div className='left-button' ref={leftRef} onClick={onLeft}><LeftSvg /></div>
            <div className='pagination-text'>{page} из {vlPages}</div>
            <div className='right-button' ref={rightRef} onClick={onRight}><RightSvg /></div>
        </div>
    )
}

export default Pagination;